export function NotFound() {
    return (
        <section className="text-center mt-20">
            <div className="flex flex-col items-center">
                <h1>404</h1>
                <p>Page not found</p>
                <a href="/" className="primary-btn">
                    Go back home
                </a>
            </div>
        </section>
    );
}
